import {
  Box,
  Button,
  Flex,
  Group,
  LoadingOverlay,
  Stack,
  Text,
  TextInput,
} from "@mantine/core";
import TextEditor from "../../../../components/ExternalEditors/TextEditor";
import { useEffect, useMemo, useRef, useState } from "react";
import { useConfigStore } from "../../../../stores/ConfigStore";
import { getFields } from "../../../../api/ContactAPI";
import { useLanguage } from "../../../../stores/LanguageStore";
import {
  editLinkedinInvitation,
  editLinkedinMessage,
  editSMS,
  findLinkedinInvitation,
  findLinkedinMessage,
  findSMS,
  generateLinkedinInvitation,
  generateLinkedinMessage,
  getLinkedinInvitations,
  getLinkedinMessages,
  getSMS,
} from "../../../../api/ModelsApi";
import { notifications } from "@mantine/notifications";
import MessageModalPreview from "../../../../components/View/MessageModalPreview";
import useNavigationBlocker from "../../../../components/View/NavigationBlocker";
import BackButton from "../../../../components/View/BackButton";
import Generator from "../emails/Generator";
import { modals } from "@mantine/modals";
import FilesModal from "../../files/FilesModal";
import { findFile } from "../../../../api/FIleAPI";
import FileItemMessage from "./FileItemMessage";

const EditModelLinkedinVocal = ({
  handleClose,
  onEdited,
  model,
}) => {
  const lang = useLanguage((s) => s.language);
  const [loading, setLoading] = useState(model?.text ? false : true);
  const [dirty, setDirty] = useState(false);

  const [modelProfile, setModelProfile] = useState(model);
  const [file, setFile] = useState(null);

  useEffect(() => {
    findLinkedinMessage(model?.id)
      .then((response) => {
        setModelProfile(response.data.model_profile);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [model]);

  useEffect(() => {
    if (modelProfile?.file_id) {
      findFile(modelProfile.file_id).then((res) => {
        setFile(res.data.file_profile);
      });
    }
  }, [modelProfile]);

  const [submitting, setSubmitting] = useState(false);
  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const fd = new FormData(e.target);
    const data = Object.fromEntries(fd);

    return editLinkedinMessage({
      id: model?.id,
      name: data.name,
      file_id: file?.id,
      text: "",
    })
      .then((response) => {
        notifications.show({
          title: lang.models.edit_success,
          message: lang.models.edit_success_text,
          color: "tertiary.8",
        });
        setDirty(false);

        if (onEdited) {
          setTimeout(() => {
            onEdited(modelProfile);
          }, 50);
        }
      })
      .catch(() => setSubmitting(false));
  };

  const handleFileAdd = (content) => {
    setFile(content.item)
  }

  useNavigationBlocker(dirty);

  return (
    <>
      <LoadingOverlay
        visible={loading || submitting}
        overlayProps={{ blur: 1 }}
        zIndex={1001}
      />

      <Stack
        component={"form"}
        onSubmit={onSubmit}
        gap={0}
        id="model-form"
        flex={1}
      >
        <Group wrap="nowrap" mb={"sm"}>
          <TextInput
            key={modelProfile?.id}
            label={lang.model_emails.create.dialog.name}
            placeholder={lang.model_emails.create.dialog.name}
            defaultValue={modelProfile?.name}
            name="name"
            w="50%"
            required
            data-autofocus
            autoFocus
            onChange={() => setDirty(true)}
            size="md"
          />
        </Group>

        {file && <FileItemMessage file={file} setFile={setFile} isVocalMessage />}

        <Group justify="space-between" mt={"sm"}>
          <FilesModal
            isLinkedin
            handleFileAdd={handleFileAdd}
            isLongButton
            buttonProps={{ size: "md", h: "100%", mr: "md" }}
            defaultType={"audio"}
            label={"Changer le message"}
            audioOnly
          />

          <Flex gap={"md"}>
            <BackButton onClick={handleClose} label={lang.global.back} size="md" />
            <Button type="submit" size="md">
              {lang.model_emails.edit.dialog.submit_button}
            </Button>
          </Flex>
        </Group>
      </Stack>
    </>
  );
};

export default EditModelLinkedinVocal;
